"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HtmlBetAdjuster = void 0;
var _HtmlButton = require("./HtmlButton");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var HtmlBetAdjuster = exports.HtmlBetAdjuster = /*#__PURE__*/function () {
  function HtmlBetAdjuster(parent, containerClasses, classes, id, headerText) {
    _classCallCheck(this, HtmlBetAdjuster);
    _defineProperty(this, "_node", void 0);
    _defineProperty(this, "_id", void 0);
    _defineProperty(this, "_value", void 0);
    //lines
    //coins
    //denomination
    this._id = id;
    this._node = document.createElement("div");
    this._node.className = "betAdjuster " + classes;
    parent.appendChild(this._node);
    var innerWrapper = document.createElement("div");
    innerWrapper.className = "innerWrapper";
    this._node.appendChild(innerWrapper);
    var header = document.createElement("div");
    header.className = "header";
    header.innerHTML = headerText;
    this._node.appendChild(header);
    this._value = document.createElement("span");
    this._value.className = "value";
    innerWrapper.appendChild(this._value);
    new _HtmlButton.HtmlButton(innerWrapper, "", "betPlus uis uis-btn_plus hShrink", id + "_PLUS");
    new _HtmlButton.HtmlButton(innerWrapper, "", "betMinus uis uis-btn_minus hShrink", id + "_MINUS");
  }
  return _createClass(HtmlBetAdjuster, [{
    key: "value",
    set: function set(value) {
      this._value.innerHTML = value;
    }
  }]);
}();
//# sourceMappingURL=HtmlBetAdjuster.js.map